 /* eslint-disable */
import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { ArcRoutes } from '../../pages/arc/constants/routes';
import { EmploymentState } from '../../pages/arc/features/employment/employment-model';
import { TcsmStates } from '../../root/tcsm-model';
import { handleExternalLinkClick } from '../helpers/url-helper';
import { useBasePath } from '../hooks/useBasePath';
import { AuthenticatedState } from '../models/authenticated-model';
import { DemographicsContext } from '../models/demographics-model';

export interface Props {
    content: string;
    className?: string;
    externalHanlder?: () => void;
}

export const WysiwygWithReactLink = (props: Props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const app = useContext(DemographicsContext);
    const authenticatedState = useSelector<TcsmStates, AuthenticatedState>(state => state.authenticatedState);
    const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
    const employeeSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${ArcRoutes.EmployeeSearch}`);
    const location = useLocation();

    const handleContentClick = (e: React.MouseEvent<HTMLDivElement>) => {
        handleExternalLinkClick(e, dispatch, history, location, authenticatedState, employmentState, app, employeeSelect, props?.externalHanlder);
    };

    return (
        <div
            dangerouslySetInnerHTML={{ __html: props.content }}
            className={`rich-text ${props.className}`}
            onClick={(e) => handleContentClick(e)}
            role='link' 
            onKeyPress={() => { }}
            aria-label='cms-content'
        />
    );
};